/** Programme group accent colors from the prototype. */
export const GROUP_COLORS: Record<string, string> = {
  schools: "#4275d4",
  care: "#a27bd9",
  dlp: "#16877c",
  education: "#c7943b",
  central: "#74859a",
};

export function groupColor(code: string): string {
  return GROUP_COLORS[code] ?? "#74859a";
}
